import {appendQueryString, IRequestMeta, request, RequestMethod} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse, RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {Country} from "../../../region/types/Country";
import type {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {PRICES_SEARCH_REGIONS_PAGE_SIZE} from "../constants/prices_search";
import type {IPricesRegionSuggestion, IPricesRegionSuggestionsResult} from "../types/IPricesSearchModel";
import {normalizeSearchText} from "../utils/normalize_search_text";

export interface IFetchPricesRegionSuggestionsOptions {
    /** PRICES_SEARCH_REGIONS_PAGE_SIZE for the first look, PRICES_SEARCH_REGIONS_EXPANDED_PAGE_SIZE for "Pokaż więcej dzielnic". */
    pageSize?: number;
    signal?: AbortSignal;
}

// Browser-only, like the main search's region list: a relative URL against the current origin.
const regionListRequest = request.create<IRequestMeta, IPaginatedResponse<IRegionListRegion>>({
    clientApiUrl: null,
    serverApiUrl: null,
    timeout: 10000
});

const PRICES_CITY_NAME_BY_SLUG = new Map<string, string>(PRICES_CITIES.map((city) => [city.slug, city.name]));

// "Bielsko Biała" has to find "Bielsko-Biała": case, diacritics, hyphens and repeated spaces do not count.
const toComparableName = (text: string): string => normalizeSearchText(text).replace(/[\s-]+/g, " ");

/**
 * Districts of the 14 prices cities and cities without a prices page for the prices search, from the RP
 * region search (the scenario the main search uses). The API matches any word of `full_name`, so a county
 * name ("bielski") or a city name ("Warszawa" → all of its districts) brings rows too - districts keep the
 * API order for the model to score, and cities outside the 14 must start with the query.
 * An empty query answers without a request; network and HTTP errors reject, an abort rejects too.
 */
export const fetchPricesRegionSuggestions = async (
    query: string,
    options: IFetchPricesRegionSuggestionsOptions = {}
): Promise<IPricesRegionSuggestionsResult> => {
    const {pageSize = PRICES_SEARCH_REGIONS_PAGE_SIZE, signal} = options;
    const fullName = query.trim();

    if (!fullName) {
        return {districts: [], citiesWithoutData: []};
    }

    const url = appendQueryString(apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL), {
        full_name: fullName,
        type: [RegionType.CITY, RegionType.DISTRICT],
        page_size: pageSize,
        country: Country.POLAND
    });
    const response = await regionListRequest({}, url, {method: RequestMethod.GET, signal});

    if (!response || !Array.isArray(response.results)) {
        throw new Error("Unexpected RP region list response");
    }

    const comparableQuery = toComparableName(fullName);
    const districts: IPricesRegionSuggestion[] = [];
    const citiesWithoutData: IPricesRegionSuggestion[] = [];

    for (const region of response.results) {
        const parentCityName = region.parent ? PRICES_CITY_NAME_BY_SLUG.get(region.parent.slug) : undefined;

        if (region.type === RegionType.DISTRICT && region.parent && parentCityName) {
            districts.push({
                kind: "district",
                regionId: region.id,
                name: region.name,
                citySlug: region.parent.slug,
                cityName: parentCityName,
                hasPricesPage: true,
                region
            });
        }

        // The 14 cities are matched locally from PRICES_CITIES, so only the others are of interest here.
        if (region.type === RegionType.CITY && !PRICES_CITY_NAME_BY_SLUG.has(region.slug) && toComparableName(region.name).startsWith(comparableQuery)) {
            citiesWithoutData.push({
                kind: "city",
                regionId: region.id,
                name: region.name,
                citySlug: null,
                cityName: null,
                hasPricesPage: false,
                region
            });
        }
    }

    // `next` rather than a full page: a page of exactly `pageSize` rows with nothing after it keeps the exact count.
    return {districts, citiesWithoutData, isTruncated: response.next !== null && response.next !== undefined};
};
import {appendQueryString, IRequestMeta, request, RequestMethod} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";
import {IPaginatedResponse, RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {Country} from "../../../region/types/Country";
import type {IRegionListRegion} from "../../../search/actions/fetch_search_regions_action";
import {PRICES_SEARCH_REGIONS_PAGE_SIZE} from "../constants/prices_search";
import type {IPricesRegionSuggestion, IPricesRegionSuggestionsResult} from "../types/IPricesSearchModel";
import {normalizeSearchText} from "../utils/normalize_search_text";

export interface IFetchPricesRegionSuggestionsOptions {
    /** PRICES_SEARCH_REGIONS_PAGE_SIZE for the first look, PRICES_SEARCH_REGIONS_EXPANDED_PAGE_SIZE for "Pokaż więcej dzielnic". */
    pageSize?: number;
    signal?: AbortSignal;
}

// Browser-only, like the main search's region list: a relative URL against the current origin.
const regionListRequest = request.create<IRequestMeta, IPaginatedResponse<IRegionListRegion>>({
    clientApiUrl: null,
    serverApiUrl: null,
    timeout: 10000
});

const PRICES_CITY_NAME_BY_SLUG = new Map<string, string>(PRICES_CITIES.map((city) => [city.slug, city.name]));

// "Bielsko Biała" has to find "Bielsko-Biała": case, diacritics, hyphens and repeated spaces do not count.
const toComparableName = (text: string): string => normalizeSearchText(text).replace(/[\s-]+/g, " ");

/**
 * Districts of the 14 prices cities and cities without a prices page for the prices search, from the RP
 * region search (the scenario the main search uses). The API matches any word of `full_name`, so a county
 * name ("bielski") or a city name ("Warszawa" → all of its districts) brings rows too - districts keep the
 * API order for the model to score, and cities outside the 14 must start with the query.
 * An empty query answers without a request; network and HTTP errors reject, an abort rejects too.
 */
export const fetchPricesRegionSuggestions = async (
    query: string,
    options: IFetchPricesRegionSuggestionsOptions = {}
): Promise<IPricesRegionSuggestionsResult> => {
    const {pageSize = PRICES_SEARCH_REGIONS_PAGE_SIZE, signal} = options;
    const fullName = query.trim();

    if (!fullName) {
        return {districts: [], citiesWithoutData: []};
    }

    const url = appendQueryString(apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL), {
        full_name: fullName,
        type: [RegionType.CITY, RegionType.DISTRICT],
        page_size: pageSize,
        country: Country.POLAND
    });
    const response = await regionListRequest({}, url, {method: RequestMethod.GET, signal});

    if (!response || !Array.isArray(response.results)) {
        throw new Error("Unexpected RP region list response");
    }

    const comparableQuery = toComparableName(fullName);
    const districts: IPricesRegionSuggestion[] = [];
    const citiesWithoutData: IPricesRegionSuggestion[] = [];

    for (const region of response.results) {
        const parentCityName = region.parent ? PRICES_CITY_NAME_BY_SLUG.get(region.parent.slug) : undefined;

        if (region.type === RegionType.DISTRICT && region.parent && parentCityName) {
            districts.push({
                kind: "district",
                regionId: region.id,
                name: region.name,
                citySlug: region.parent.slug,
                cityName: parentCityName,
                hasPricesPage: true,
                region
            });
        }

        // The 14 cities are matched locally from PRICES_CITIES, so only the others are of interest here.
        if (region.type === RegionType.CITY && !PRICES_CITY_NAME_BY_SLUG.has(region.slug) && toComparableName(region.name).startsWith(comparableQuery)) {
            citiesWithoutData.push({
                kind: "city",
                regionId: region.id,
                name: region.name,
                citySlug: null,
                cityName: null,
                hasPricesPage: false,
                region
            });
        }
    }

    // `next` rather than a full page: a page of exactly `pageSize` rows with nothing after it keeps the exact count.
    return {districts, citiesWithoutData, isTruncated: response.next !== null && response.next !== undefined};
};
